import { Checkbox, Button } from 'antd'
import $t from '../../../../i18n'

import './ChangePcpContainer.css'

const ChangePcpContainer = ({
  provider,
  onChangePcpSelection,
  onConfirmPcpSelection,
  changePcpSelectedProviderId
}) => {
  return (
    <div className='change-pcp-flow-section'>
      <div
        className='change-pcp-flow-section-select'
        onClick={() => {
          onChangePcpSelection(provider?.id)
        }}
      >
        <Checkbox
          className='change-pcp-flow-select-checkbox'
          checked={changePcpSelectedProviderId === provider?.id}
          onChange={() => {
            onChangePcpSelection(provider?.id)
          }}
        />
        <span className='change-pcp-flow-label'>
          {`Select this doctor for office visits`}
        </span>
      </div>
      {changePcpSelectedProviderId === provider?.id && (
        <Button
          className='change-pcp-flow-confirm-button'
          onClick={() => onConfirmPcpSelection(provider)}
        >
          {$t('common.confirm')}
        </Button>
      )}
    </div>
  )
}

export default ChangePcpContainer
